<template>
  <div class="relative">
    <div class="hidden lg:block absolute top-8 left-[12.5%] right-[12.5%] h-0.5 bg-gradient-to-r from-transparent via-brand-primary/40 to-transparent" aria-hidden="true"></div>

    <div class="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="group relative flex flex-col items-center text-center"
      >
        <div class="relative z-10 mb-6">
          <div class="absolute inset-0 rounded-full bg-brand-primary opacity-30 blur-xl group-hover:opacity-50 transition-opacity"></div>
          <div class="relative flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-brand-primary to-brand-secondary shadow-lg ring-4 ring-gray-900">
            <span class="text-2xl font-bold text-white">{{ index + 1 }}</span>
          </div>
        </div>

        <div class="flex w-full flex-1 flex-col rounded-2xl border border-gray-700 bg-gray-800/60 p-6 transition-all duration-300 group-hover:border-brand-primary group-hover:bg-gray-800/80 group-hover:-translate-y-1">
          <div class="mb-4 flex justify-center">
            <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-primary/10 ring-1 ring-brand-primary/20">
              <component :is="getIcon(step.icon)" class="h-6 w-6 text-brand-accent" />
            </div>
          </div>

          <h3 class="mb-2 text-lg font-semibold text-white">
            {{ step.title }}
          </h3>

          <p class="mb-4 flex-1 text-sm leading-relaxed text-gray-400">
            {{ step.description }}
          </p>

          <p v-if="step.note" class="mt-auto text-xs font-medium text-brand-accent">
            {{ step.note }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { h } from 'vue';

defineProps({
  steps: {
    type: Array,
    required: true,
    validator: (steps) =>
      steps.every((s) => s.icon && s.title && s.description),
  },
});

const ICON_PATHS = {
  qrcode: 'M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-4 4h2v2h-2v-2zm4 0h2v2h-2v-2z',
  chat: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
  route: 'M9 5l7 7-7 7M3 12h13',
  trending: 'M3 17l6-6 4 4 8-8M14 7h7v7',
  star: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z',
};

function getIcon(name) {
  const d = ICON_PATHS[name] || ICON_PATHS.star;
  return (props) =>
    h(
      'svg',
      { ...props, fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' },
      [
        h('path', {
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'stroke-width': '2',
          d,
        }),
      ],
    );
}
</script>
